import {
  Activity,
  BrainCircuit,
  GraduationCap,
  Handshake,
  HeartPulse,
  Landmark,
  MapPinned,
  Megaphone,
  Plane,
  School,
  Smartphone,
  Truck,
  Tv,
  UsersRound,
  type LucideIcon,
} from 'lucide-react'
import type { IconKey } from '../content/types'

export const iconByKey: Record<IconKey, LucideIcon> = {
  people: UsersRound,
  truck: Truck,
  tv: Tv,
  map: MapPinned,
  plane: Plane,
  heart: HeartPulse,
  megaphone: Megaphone,
  handshake: Handshake,
  brain: BrainCircuit,
  smartphone: Smartphone,
  landmark: Landmark,
  school: School,
}

export const fallbackIcon = Activity
export const educationIcon = GraduationCap
